import React from "react";
import StreakSmallOpponent from "./StreakSmallOpponent";
import LogoOrTitle from "./LogoOrTitle";

const TeamStreakRow = ({ team, games, logoOnRightSide }) => {
  return (
    <div className="mt-2 flex border-y border-white">
      {logoOnRightSide ? (
        <>
          {games.map((game, index) => (
            <StreakSmallOpponent key={index} game={game} />
          ))}
          <LogoOrTitle
            logo={team.logo}
            title={team.name}
            titleClassName="text-center"
            className="ml-2 h-16 w-16 rounded-full"
          />
        </>
      ) : (
        <>
          <LogoOrTitle
            logo={team.logo}
            title={team.name}
            titleClassName="text-center"
            className="mr-2 h-16 w-16 rounded-full"
          />
          {games.map((game, index) => (
            <StreakSmallOpponent key={index} game={game} />
          ))}
        </>
      )}
    </div>
  );
};

export default TeamStreakRow;
